import React, {useContext, useState} from "react";
import "./GeneralProject.scss";
import {bigProjects} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function GeneralProject() {
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isWidgetVisible, setIsWidgetVisible] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const handleCategoryClick = category => {
    setSelectedCategories(prevSelected =>
      prevSelected.includes(category)
        ? prevSelected.filter(cat => cat !== category)
        : [...prevSelected, category]
    );
  };

  const filteredProjects = bigProjects.projects.filter(project =>
    selectedCategories.every(category => project.categories.includes(category))
  );

  const handleProjectClick = project => {
    setSelectedProject(project);
    setIsWidgetVisible(true);
  };

  const closeWidget = () => {
    setIsWidgetVisible(false);
    setSelectedProject(null);
  };

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const initialProjectsToShow = 4;
  const projectsToDisplay = showAll
    ? filteredProjects
    : filteredProjects.slice(0, initialProjectsToShow);

  const {isDark} = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }
  return (
    <>
      <Fade bottom duration={1000} distance="20px">
        <div className="main" id="projects">
          <div>
            <h1 className="skills-heading">{bigProjects.title}</h1>
            <p
              className={
                isDark
                  ? "dark-mode project-subtitle"
                  : "subTitle project-subtitle"
              }
            >
              {bigProjects.subtitle}
            </p>
            <div className="category-filter">
              {[
                "Bioinformatics",
                "Engineering",
                "Machine Learning",
                "Networking",
                "Research",
                "Software Engineering",
                "Web Development"
              ].map(category => (
                <button
                  key={category}
                  onClick={() => handleCategoryClick(category)}
                  className={
                    selectedCategories.includes(category)
                      ? "selected-category"
                      : "category"
                  }
                >
                  {category}
                </button>
              ))}
            </div>

            <div className="projects-container">
              {projectsToDisplay.map((project, i) => {
                return (
                  <div
                    key={i}
                    className={
                      isDark
                        ? "dark-mode project-card project-card-dark"
                        : "project-card project-card-light"
                    }
                    onClick={() => handleProjectClick(project)}
                  >
                    {project.image ? (
                      <div className="project-image">
                        <img
                          src={project.image}
                          alt={project.projectName}
                          className="card-image"
                        ></img>
                      </div>
                    ) : null}
                    <div className="project-detail">
                      <h5
                        className={
                          isDark ? "dark-mode card-title" : "card-title"
                        }
                      >
                        {project.projectName}
                      </h5>
                      <p
                        className={
                          isDark ? "dark-mode card-subtitle" : "card-subtitle"
                        }
                      >
                        {project.projectDesc}
                      </p>
                      {project.footerLink ? (
                        <div className="project-card-footer">
                          {project.footerLink.map((link, i) => {
                            return (
                              <span
                                key={i}
                                className={
                                  isDark
                                    ? "dark-mode project-tag"
                                    : "project-tag"
                                }
                                onClick={() => openUrlInNewTab(link.url)}
                              >
                                {link.name}
                              </span>
                            );
                          })}
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="show-more-button-container">
              <button className="show-more-button" onClick={toggleShowAll}>
                {showAll ? "Collapse Projects" : "More Projects!"}
              </button>
            </div>
          </div>
        </div>
      </Fade>
      {isWidgetVisible && (
        <>
          <div className="blur-background" onClick={closeWidget}></div>
          <div
            className={
              isDark
                ? "dark-mode project-widget project-widget-dark"
                : "project-widget project-widget-light"
            }
          >
            <div className="widget-content">
              <h2>{selectedProject.projectName}</h2>
              {selectedProject.image ? (
                <div className="widget-image">
                  <img
                    src={selectedProject.image}
                    alt={selectedProject.projectName}
                    className="widget-image"
                  ></img>
                </div>
              ) : null}
              <div
                dangerouslySetInnerHTML={{
                  __html: selectedProject.extraInformationHtml
                }}
              ></div>
              <button onClick={closeWidget}>Close</button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
